import * as yup from 'yup';
export const addPartnerStep3Validation = yup.object().shape({
    bicNumber: yup.string().required('BIC is required'),
    ibanNumber: yup.string().required('IBAN is required'),
});
